import { useMessageStore } from '../stores/messageStore'
import { useToastStore } from '../stores/toastStore'
import { useGTMStore } from '../stores/gtmStore'
import ServiceSchemaError from '@/modules/core/models/errors/ServiceSchemaError'
import ServiceError from '@/modules/core/models/errors/ServiceError'
import { ErrorDisplayTypeEnum, MessageEnum, ServiceErrorCodeEnum } from '../models/enums'
import GTMPageType from '../models/GTMPageType'
import ConsoleError from '../models/errors/ConsoleError'
import { useInsightStore } from '../stores/insightStore'

export function useErrorManagerComposable() {
  const messageStore = useMessageStore()
  const toastStore = useToastStore()
  const gtmStore = useGTMStore()
  const insightStore = useInsightStore()

  function _isCustomServerError(errorCode: string | number | null | undefined) {
    if (!errorCode) return false

    const codeErrors: string[] = Object.values(ServiceErrorCodeEnum)
    return codeErrors.includes(String(errorCode))
  }

  function _getToastMethodBy(type: MessageEnum) {
    if (type === MessageEnum.WARNING) {
      return toastStore.warningToast
    }

    return toastStore.errorToast
  }

  //* Error en el servicio
  function handlerServiceError(error: ServiceError) {
    console.error(`Error en el servicio: ${error.serviceName}`)
    insightStore.trackException(error, 2, { payload: error.payload })

    if (_isCustomServerError(error.code)) {
      error.setTitle(`copy_custom-error-code_${error.code}`)
    }

    if (error.displayType === ErrorDisplayTypeEnum.MODAL) {
      messageStore.errorModal(error.modalConfiguration)
      gtmStore.pageEvent(GTMPageType.ERROR)
      throw error // * Nos interesa para la ejecucion
    }

    const toastMethod = _getToastMethodBy(error.type)
    if (error.displayType === ErrorDisplayTypeEnum.TOAST) {
      toastMethod(error.title, false)
      return
    }

    if (error.displayType === ErrorDisplayTypeEnum.TOAST_IN_MODAL) {
      toastMethod(error.title, true)
      return
    }
  }

  //* Error en la estructura de datos del servicio
  function handlerSchemeError(error: ServiceSchemaError) {
    if (error.displayType === ErrorDisplayTypeEnum.MODAL) {
      messageStore.errorModal(error.modalConfiguration)
      throw error // * Nos interesa para la ejecucion
    }

    const toastMethod = _getToastMethodBy(error.type)
    if (error.displayType === ErrorDisplayTypeEnum.TOAST) {
      toastMethod(error.title, false)
      return
    }

    if (error.displayType === ErrorDisplayTypeEnum.TOAST_IN_MODAL) {
      toastMethod(error.title, true)
      return
    }

    if (error.displayType === ErrorDisplayTypeEnum.WITHOUT_TOAST) return
  }

  function handlerConsoleError(error: ConsoleError) {
    insightStore.trackException(error)
    //console.error(error.message)
  }

  function handleError(error: any) {
    if (error instanceof ConsoleError) {
      return handlerConsoleError(error)
    }

    if (error instanceof ServiceSchemaError) {
      return handlerSchemeError(error)
    }

    if (error instanceof ServiceError) {
      return handlerServiceError(error)
    }

    console.error(error.stack)
  }
  function handleErrorInsight(error: any) {
    insightStore.trackException(error)
  }

  return {
    handleError,
    handleErrorInsight
  }
}
